import React, { useState } from 'react';
import { validateEmail } from './utils/helpers';
// import { Mailer } from 'nodemailer-react'
// require("dotenv").config();

function ContactForm() {

    const [formState, setFormState] = useState({ name: '', email: '', message: '' });

    const [errorMessage, setErrorMessage] = useState('');

    const { name, email, message } = formState;



    function handleChange(e) {
        setFormState({...formState, [e.target.name]: e.target.value })
    }

    const handleSubmit = (e) => {
        e.preventDefault(); 
        alert('Thank you for submitting your request in the contact form. Your request has been submitted via email.');
        setFormState({ name: '', email: '', message: '' })
    }
    
    const handleReset = (e) => {
        e.preventDefault(); 
        setFormState({ name: '', email: '', message: '' });
    }

return (
    <section className="container contactContainerForm">
        <h2 className="top-title">Contact Form</h2>
        <hr></hr>
        <form className="contact-form" id="contact-form">
            <div className="mt-5 contact-name" >
                <label htmlFor="name">Name:</label>
                <input className="form-control" type="text" required="true" name="name" placeholder="Enter your name" value={name} onChange={handleChange}/>
            </div>
            <div className="mt-5 contact-email" >
                <label htmlFor="email">Email Address:</label>
                <input className="form-control" type="email" placeholder="Enter your email" name="email" value={email} onChange={handleChange} required/>
            </div>
            <div className="mt-5 contact-message" >
                <label htmlFor="message">Message:</label>
                <textarea className="form-control" name="message" placeholder="Enter your message" value={message} onChange={handleChange} rows="7" />
            </div> 
            {errorMessage && (
            <div>
                <p className="error-text">{errorMessage}</p>
            </div>
            )}

            <div className="mt-5 mb-5" >
            <button data-id='button' className="btn btn-outline-dark " type="submit" onClick={handleSubmit}>Submit</button>
            <button data-id='button' className="btn btn-outline-dark " type="reset" onClick={handleReset} style={{ color: 'white', backgroundColor: 'red' }}>Clear Form</button>
            </div>
        </form>
    </section>
    );
}
    
export default ContactForm;